import { render, staticRenderFns } from "./ChangeEventSettings.vue?vue&type=template&id=611bd386&scoped=true&"
import script from "./ChangeEventSettings.vue?vue&type=script&lang=js&"
export * from "./ChangeEventSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEventSettings.vue?vue&type=style&index=0&id=611bd386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611bd386",
  null
  
)

export default component.exports